import { Suspense } from "react";
import { Outlet } from "react-router-dom";
import ErrorBoundary from "../components/ErrorBoundary";
import Loader from "../components/Fallbacks/Loader";
import Error from "../components/Fallbacks/Error";
import FilterContext from "../components/Filters/FilterContext";
import { useWindowSize } from "../hooks/useWindowSize";

export function App() {
  useWindowSize();

  return (
    <ErrorBoundary fallback={({ error }: any) => <Error error={error} />}>
      <FilterContext>
        <Suspense fallback={<Loader />}>
          <Outlet />
        </Suspense>
      </FilterContext>
    </ErrorBoundary>
  );
}

export default App;
